import { PersistedState } from 'runed';
import { getTileId } from '~/algorithms/letters';

export const playerName = new PersistedState('displayName', '');

export const sessionId = new PersistedState('sessionId', getTileId(), {
  storage: 'session',
});

export const pendingVerification = new PersistedState(
  'pending-verification',
  '',
  {
    storage: 'session',
  },
);
